import React from 'react';

import { Icon } from 'antd';


const Button = ({clickHandler, type, children}) => (
    <a href="javascript:;"
    onClick={clickHandler}
    >
    <Icon type={type || "file"} />{children}
    </a>
);

export default Button;